
function getPoiCsvContent(poiList) {
  var location;
  var csv = 'Name,Latitude,Longitude,Mode\n';
  poiList.forEach(poi => {
    location = poi.location || [null, null];
    csv += [`"${poi.name}"`, location[1], location[0], poi.mode].join(',');
    csv += "\n";
  });
  return csv;
}


export default {
  state: {
    poiSetsData: undefined,
    poiSetsFailed: false,
  },
  getters: {
    poiSetsLoading (state) {
      return !state.poiSetsData && !state.poiSetsFailed
    },
    poiSets (state) {
      return state.poiSetsData !== undefined ? state.poiSetsData : []
    }
  },
  mutations: {
    clearPoiSets (state) {
      state.poiSetsData = undefined;
    },
    setPoiSets (state, data) {
      state.poiSetsData = Object.freeze(data);
    },
    setPoiSetsFailed (state, failed) {
      state.poiSetsFailed = failed;
    },
  },
  actions: {
    async getPoiSetsData(context) {
      if (context.state.poiSetsData !== undefined) return;

      context.commit('setPoiSetsFailed', false);
      await context.rootState.inst.get(
        `/api/poi-sets/sets/`,
        {backgroundRequest: true}
      ).then((response) => {
        context.commit('setPoiSets', response.data);
      }).catch(() => {
        context.commit('setPoiSetsFailed', true);
      });
    },
    async postPoiSet(context, {data}) {
      await context.rootState.inst.post(
        '/api/poi-sets/sets/',
        data,
        {headers: {'Content-Type': 'multipart/form-data' }}
      ).then(() => {
        context.commit('clearPoiSets');
        context.dispatch('getPoiSetsData');
      });
    },
    async patchPoiSets(context, {set_name, data}) {
      await context.rootState.inst.patch(
        `/api/poi-sets/sets/${set_name}/`,
        data,
        {headers: {'Content-Type': 'multipart/form-data' }}
      ).then(() => {
        context.commit('clearPoiSets');
        context.dispatch('getPoiSetsData');
      });
    },
    async deletePoiSet(context, {set_name}) {
      await context.rootState.inst.delete(
        `/api/poi-sets/sets/${set_name}/`,
      ).then(() => {
        context.commit('clearPoiSets');
        context.dispatch('getPoiSetsData');
      });
    },
    async downloadPoiData(context, {set_name}) {
      await context.rootState.inst.get(
        `/api/poi-sets/data/?set_name=${set_name}`
      ).then((response) => {
        const csvContent = getPoiCsvContent(response.data);
        const file = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
        const fileName = "Points Of Interest.csv"

        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(file, fileName);
        } else {
          const a = document.createElement('A');
          a.href = URL.createObjectURL(file);
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      });
    },
  }
}